import React, { useState } from 'react';
import clsx from 'clsx';
import {
  Element,
  Size,
  Color,
  TabGroupWithContent,
  Icon,
  MatchHeightProvider
} from '@americanexpress/aqx-components';
import { sendDTMEvents } from 'service_modules/models/dtm-tagging';
import stylesLayout from './__styles__/index.scss?modules';
import styles from './__styles__/tabControl.scss?modules';

import TabContent from './TabContent';
let instNum = 0;
const getInstId = () => {
  instNum = instNum + 1;
  return `inst${instNum}`;
};

const buildTabItems = (contentList, instId) => {
  return (contentList || []).map((item, i) => {
    return {
      Component: ({ isActive }) => (
        <Element className={clsx(styles.tabHeader, { [styles.selected]: isActive })}>
          <Icon
            directory="dls"
            imageName={isActive ? item.svgIconFilled : item.svgIcon}
            className={styles.icon}
            $size={Size.SM}
            theme={{
              color: isActive ? Color.DeepBlue : Color.BrightBlue,
              marginRight: 10,
              marginBottom: 0
            }}
          />
          {item.title}
        </Element>
      ),
      tabId: `tab-${instId}-${i}`,
      qeId: instId
    };
  });
};

const TabControl = ({ contentList = [], ...otherProps }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const instId = getInstId();
  const tabProps = {
    tabItems: buildTabItems(contentList, instId),
    data: (contentList || []).map((item, i) => {
      const props = {
        activeIndex,
        content: item,
        index: i,
        ...otherProps
      };
      return {
        content: <TabContent {...props} />,
        id: `tabpanel-TabGroupWithContent-${instId}-${i}`,
        ariaLabelledBy: `tab-${instId}-${i}`,
        qeId: instId
      };
    }),
    onTabIndexChange: selectedIndex => {
      setActiveIndex(selectedIndex);
      const { dtmEvents } = contentList[selectedIndex] || {};
      sendDTMEvents(dtmEvents);
    },
    shouldStayHorizontal: true,
    qeId: instId
  };

  return (
    <Element className={clsx(styles.tabControl, stylesLayout.tabOuter)}>
      <MatchHeightProvider isResponsive={true}>
        <TabGroupWithContent {...tabProps} />
      </MatchHeightProvider>
    </Element>
  );
};

export default React.memo(TabControl);
